import { PROBLEM_CODES, ProblemCode } from '@quizdb/common';

/** Reads the task bank's problem code (QZ-D42) out of an RTK Query error, if there is one. */
export const problemCode = (error: unknown): ProblemCode | undefined => {
  if (typeof error !== 'object' || error === null || !('data' in error)) {
    return undefined;
  }
  const { data } = error as { data: unknown };
  if (typeof data !== 'object' || data === null || !('code' in data)) {
    return undefined;
  }
  const { code } = data as { code: unknown };
  return typeof code === 'string' && Object.hasOwn(PROBLEM_CODES, code)
    ? (code as ProblemCode)
    : undefined;
};
